import styled from 'styled-components'
import PageLayout from '../../components/PageLayout'
import React, { useContext, useState } from 'react'
import { AppContext } from '../../Context'
import { RecordContext } from './RecordPage'
import { get } from 'lodash'
import { useHistory } from 'react-router'
import Stepper from '../../components/Stepper'
import EmployeeContactForm from '../../components/EmployeeContactForm'

const EmployeeContactContainer = styled(PageLayout)`
  .labelField{
    margin-bottom:20px;
  }  
`

function EmployeeContact({ ...props }) {

  const history = useHistory()

  const { employee, setEmployee, originalEmployee, updateEmployeeContact } = useContext(AppContext)
  const { record, steps, parentHistory } = useContext(RecordContext)

  const [error, setError] = useState({})
  const [submitError, setSubmitError] = useState('')
  const [canSave, setCanSave] = useState(false)

  const save = async () => {
    if (employee.phoneNumber !== originalEmployee.phoneNumber || employee.email !== originalEmployee.email) {
      setCanSave(false)
      const response = await updateEmployeeContact(employee)
      if (response && response.errors) {
        setSubmitError(response.errors[0].message)
        return false
      } else {
        setSubmitError('')
      }
    }
    return true
  }

  const saveAndNext = async () => {
    const saved = await save()
    if (saved) {
      history.push('/attachment')
      return true
    }
  }

  const saveAndExit = async () => {
    const saved = await save()
    if (saved) {
      parentHistory.push('/')
      return true
    }
  }

  return (
    <EmployeeContactContainer title="2 | Mes coordonnées"
                              prevLink='/child-info'
                              actions={ {
                                submitTxt: 'Suivant',
                                onSubmit: saveAndNext,
                                disableSubmit: !canSave,
                                onCancel: saveAndExit,
                                cancelTxt: 'Enregistrer et revenir plus tard',
                                // We can even save and exit unless every mandatory field has been defined correctly.
                                disableCancel: !canSave
                              } }>

      <Stepper steps={ steps } activeStep={ 1 }/>

      <EmployeeContactForm employee={ employee } record={ record } editable={ !get(record, 'disabled') }
                           error={ error } submitError={ submitError }
                           onEmployeeChange={ setEmployee } onErrorChange={ setError }
                           onCanSaveChange={ setCanSave }/>

    </EmployeeContactContainer>
  )
}

export default EmployeeContact
